<template>
  <van-row type="flex">
    <van-col class="side-nav" ref="sideNav" style="min-width: 80px">
      <van-sticky class="side-stick" :content="sideNav" :offset-top="46">
        <van-sidebar v-model="activeKey">
          <van-sidebar-item title="热门" to="/forum" />
          <van-sidebar-item
            v-for="(cate, i) in askCate"
            :title="cate.title"
            :badge="cate.newest"
            :key="i"
            :to="{ path: '/forum', query: { catid: cate.id } }"
          />
          <van-sidebar-item title="返回专题" :to="'/' + year" />
        </van-sidebar>
      </van-sticky>
    </van-col>
    <van-col class="main-box" span="20">
      <!-- 搜索 -->
      <van-search
        v-model="params.keyword"
        placeholder="请输入搜索关键词"
        @search="searchAsk()"
      />
      <!-- 生肖广告 -->
      <router-link class="sxLinkBar" :to="'/' + year">
        <van-image :src="sxAdv" radius="5" />
      </router-link>
      <!-- 列表 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="nextPage"
      >
        <van-cell
          v-for="(item, i) in list"
          :key="i"
          :title="item.content"
          title-class="ask-title"
          :to="'/forum/view?id=' + item.id"
          is-link
        >
          <template #label>
            <div class="flex-x flex-fe">
              <div class="label-item flex flex-fe">
                <van-tag class="mgs-r" type="primary" plain>{{
                  item.cate || '未知'
                }}</van-tag>
                <van-tag
                  class="mgs-r"
                  :type="item.status ? 'success' : 'danger'"
                  plain
                  >{{ item.status ? '已回答' : '未回答' }}</van-tag
                >
                <van-tag class="mgs-r" type="default" icon="good-job" plain>
                  <van-icon name="good-job" />
                  {{ item.good }}
                </van-tag>
              </div>
              <div class="fe-full"></div>
              <span>{{ item.add_time }}</span>
            </div>
          </template>
        </van-cell>
      </van-list>
    </van-col>
  </van-row>
</template>

<script>
import { mapState } from 'vuex'
import { Search } from 'vant'
export default {
  components: {
    [Search.name]: Search
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      sideNav: null,
      activeKey: 0,
      sxAdv: require('../assets/img/sx-adv.png'),
      params: {
        page: 0,
        catid: '',
        keyword: ''
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    let query = to.query
    this.$set(this.params, 'catid', query.catid)
    this.$set(this.params, 'page', 1)
    // 切换分类时，置空列表
    this.list = []
    this.loadData()
    next()
  },
  computed: {
    ...mapState(['askCate', 'year', 'sellid'])
  },
  mounted() {
    this.sideNav = this.$refs.sideNav
    let query = this.$route.query
    if (query.catid) {
      this.$set(this.params, 'catid', query.catid)
    }
  },
  methods: {
    // 搜索
    searchAsk() {
      this.list = []
      this.loadData()
    },
    // 下一页
    nextPage() {
      let params = this.params
      this.$set(this.params, 'page', params.page + 1)
      this.loadData()
      console.log('nextPage')
    },
    // 加载数据
    loadData() {
      let params = this.params
      params['sellid'] = this.sellid || ''
      for (const key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      this.$axios.get('/crm/forum/search', { params: params }).then((res) => {
        let data = res.data
        let list = data.list.data
        for (const key in list) {
          this.list.push(list[key])
        }
        this.$store.commit('setAskCate', data.cate)
        this.loading = false
        if (data.list.current_page >= data.list.last_page) {
          this.finished = true
        } else {
          this.finished = false
        }
        this.setCurCate()
      })
      console.log('loadData')
    },
    setCurCate() {
      let query = this.$route.query
      let activeKey = 0
      this.askCate.forEach((elm, i) => {
        if (elm.id == query.catid) {
          activeKey = i + 1
        }
      })
      this.activeKey = activeKey
    }
  }
}
</script>

<style lang="scss" scoped>
.main-box {
  z-index: 100;
  border-left: #eee solid 1px;
}
.side-nav {
  background-color: #f7f8fa;
}
.ask-title {
  text-align: left;
}
.ask-title > span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  line-clamp: 2;
  -webkit-line-clamp: 2;
}
.van-sidebar /deep/ .van-sidebar-item--select {
  color: #c00;
}
.sxLinkBar {
  padding: 5px;
  background-color: #fff;
  display: block;

  .van-image {
    border: #c00 solid 1px;
    display: block;
  }
}
</style>